import { Form } from "semantic-ui-react";

const AddAttendee = (props) => {
  const { newAttendee, setNewAttendee, setSelectedJob, selectedJob } = props;
  const groups = [
    { text: "Staff", value: "Staff" },
    { text: "Witness", value: "Witness" },
    { text: "Defense", value: "Defense" },
    { text: "Plaintiff", value: "Plaintiff" },
    { text: "Group A", value: "Group A" },
    { text: "Group B", value: "Group B" },
    { text: "Group C", value: "Group C" },
    { text: "Group D", value: "Group D" },
    { text: "Group E", value: "Group E" },
    { text: "Group F", value: "Group F" },
    { text: "Group G", value: "Group G" },
    { text: "Group H", value: "Group H" },
    { text: "Group I", value: "Group I" },
    { text: "Group J", value: "Group J" },
    { text: "Group K", value: "Group K" },
    { text: "Group L", value: "Group L" },
  ];

  const handleChange = (e, data) => {
    let obj = { ...newAttendee };
    Object.assign(obj, { [data.id]: data.value });
    setNewAttendee(obj);
    // also update the main job object with a string
    let jobObj = { ...selectedJob };
    Object.assign(jobObj, { newAttendees: JSON.stringify(obj) });
    setSelectedJob(jobObj);
  };

  return (
    <Form size="large">
      <Form.Input
        id="guestName"
        label="Attendee Name"
        placeholder="Name"
        value={newAttendee.guestName}
        onChange={handleChange}
      />
      <Form.Input
        id="email"
        label="Attendee Email"
        placeholder="Email"
        value={newAttendee.email}
        onChange={handleChange}
      />
      <Form.Select
        id="group"
        label="Attendee Group"
        placeholder="Group"
        options={groups}
        value={newAttendee.group}
        onChange={handleChange}
      />
    </Form>
  );
};

export default AddAttendee;
